import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import "./button.css";

const BackButton = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <button className="custom-back-btn" onClick={handleBack}>
      <ArrowBackIosNewIcon className="back-icon" />
      <span>Back</span>
    </button>
  );
};

export default BackButton;
